/*
  Figma homepage refresh (desktop) - companion to custom-figma-desktop.css.
  Hero + categories tiles: the label (which has its own rolling hover and
  sits above the tile's full-size link) passes its click on to that link.
*/
(function () {
  document.addEventListener('click', function (event) {
    var info = event.target.closest && event.target.closest('.hfg__tile--cat .hfg__info');
    if (!info) return;
    var link = info.closest('.hfg__tile').querySelector('.hfg__link');
    if (!link) return;
    event.preventDefault();
    link.click();
  });
})();

/*
  Popular products cards (homepage, desktop) and collection page cards
  (#product-grid): clicking a size in the hover Quick View strip opens
  Quick View (Rachel, Oct 27 - before, it added the size straight to the
  cart). An in-stock size is picked for the shopper in Quick View; a
  sold-out size just opens it. offe-product-rails.js does the same on the
  product page rows.
*/
(function () {
  var DESKTOP = '(min-width: 1160px)';
  function pickInQuickView(value) {
    var tries = 0;
    (function poll() {
      var modal = document.querySelector('quick-view-modal[open]');
      var input = modal && Array.prototype.find.call(modal.querySelectorAll('input[type="radio"]'), function (i) {
        return i.value === value && !i.disabled && !i.classList.contains('disabled');
      });
      if (input) {
        if (!input.checked) {
          var label = modal.querySelector('label[for="' + input.id + '"]');
          if (label) label.click(); else input.click();
        }
        return;
      }
      if (++tries < 40) setTimeout(poll, 100);
    })();
  }
  window.offeSizeToQuickView = function (label) {
    var input = document.getElementById(label.htmlFor);
    var card = label.closest('.product-card');
    var quickView = card && card.querySelector('.product-card__quickview .product-card__button');
    if (!quickView) return;
    quickView.click();
    if (input && !input.disabled && !input.classList.contains('disabled')) pickInQuickView(input.value);
  };
  document.addEventListener('click', function (event) {
    if (!window.matchMedia(DESKTOP).matches) return;
    var label = event.target.closest && event.target.closest('.popular-products-section .product-card__information-bottom .product-card__option-group[data-option-position] label, #product-grid .product-card__information-bottom .product-card__option-group[data-option-position] label');
    if (!label) return;
    event.preventDefault();
    event.stopPropagation();
    window.offeSizeToQuickView(label);
  }, true);
})();

/*
  Colour dots with no known colour name arrive grey with data-sample (a
  small copy of that colour's photo); this fills them with the photo's main
  colour, ignoring the backdrop (corner colour) and near-white pixels.
*/
(function () {
  function sample(dot) {
    var src = dot.getAttribute('data-sample');
    if (!src) return;
    dot.removeAttribute('data-sample');
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var size = 32;
        var canvas = document.createElement('canvas');
        canvas.width = size; canvas.height = size;
        var ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, size, size);
        var data = ctx.getImageData(0, 0, size, size).data;
        var px = function (x, y) { var i = (y * size + x) * 4; return [data[i], data[i + 1], data[i + 2]]; };
        var corners = [px(0, 0), px(size - 1, 0), px(0, size - 1), px(size - 1, size - 1)];
        var bg = [0, 1, 2].map(function (k) { return (corners[0][k] + corners[1][k] + corners[2][k] + corners[3][k]) / 4; });
        var r = 0, g = 0, b = 0, n = 0;
        for (var y = 4; y < size - 4; y++) {
          for (var x = 4; x < size - 4; x++) {
            var p = px(x, y);
            var dBg = Math.abs(p[0] - bg[0]) + Math.abs(p[1] - bg[1]) + Math.abs(p[2] - bg[2]);
            if (dBg < 60) continue;
            if (p[0] > 235 && p[1] > 235 && p[2] > 235) continue;
            r += p[0]; g += p[1]; b += p[2]; n++;
          }
        }
        if (n < 12) return;
        dot.style.setProperty('--swatch', 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')');
      } catch (e) { /* photo not readable: keep the grey */ }
    };
    img.src = src;
  }
  function run() {
    if (!window.matchMedia('(min-width: 1160px)').matches) return;
    document.querySelectorAll('.popular-products-section .offe-swatch[data-sample], #product-grid .offe-swatch[data-sample]').forEach(sample);
  }
  function start() {
    run();
    /* collection pages: cards added by Show more / filters get their dots too */
    var grid = document.getElementById('product-grid');
    if (grid && window.MutationObserver) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 150); })
        .observe(grid.parentNode || grid, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/*
  Spotlight cards: the label becomes a link to the card's collection
  (a.offe-spot-link) and a photo click opens it (not after a drag).
*/
(function () {
  function linkLabels() {
    document.querySelectorAll('.spotlight-cards__item').forEach(function (item) {
      var btn = item.querySelector('.spotlight-cards__card-btn');
      var heading = item.querySelector('.spotlight-cards__item-heading');
      if (!btn || !heading || heading.querySelector('.offe-spot-link') || !btn.getAttribute('href')) return;
      var a = document.createElement('a');
      a.className = 'offe-spot-link';
      a.href = btn.getAttribute('href');
      a.textContent = heading.textContent.trim();
      heading.textContent = '';
      heading.appendChild(a);
    });
  }
  var downX = null, downY = null;
  document.addEventListener('pointerdown', function (e) { downX = e.clientX; downY = e.clientY; }, true);
  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest('.spotlight-cards__image-wrapper');
    if (!img) return;
    if (downX !== null && (Math.abs(e.clientX - downX) > 6 || Math.abs(e.clientY - downY) > 6)) return;
    var item = img.closest('.spotlight-cards__item');
    var link = item && (item.querySelector('.offe-spot-link') || item.querySelector('.spotlight-cards__card-btn'));
    if (link && link.href) window.location.href = link.href;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', linkLabels); else linkLabels();
})();

/*
  Drop-down menu tiles (desktop): every hover picks a random shape and
  backdrop colour; neighbouring tiles (incl. above/below in the Brands
  2 x 2 grid) never share one, and a tile avoids its own last pick. Read by
  custom-mega-menu.css (--fmm-morph-*). The new shape's "square" rest
  outline is swapped in first with no transition, then the morph plays.
*/
(function () {
  var SHAPES = ['clover', 'star', 'scallop']; // Offe's shapes only (no burst)
  var COLORS = ['#ff693d', '#bdbe40', '#a9defe', '#7598e9', '#629b26', '#c1b3ff'];
  var COLS = 2; // both tile layouts are two across
  function neighbours(tile) {
    var all = Array.prototype.slice.call(tile.parentNode.querySelectorAll(':scope > .fmm__tile--shape'));
    var i = all.indexOf(tile), out = [];
    if (i % COLS > 0) out.push(all[i - 1]);
    if (i % COLS < COLS - 1 && all[i + 1]) out.push(all[i + 1]);
    if (all[i - COLS]) out.push(all[i - COLS]);
    if (all[i + COLS]) out.push(all[i + COLS]);
    return out;
  }
  function pick(list, banned, own) {
    var ok = list.filter(function (v) { return banned.indexOf(v) < 0 && v !== own; });
    if (!ok.length) ok = list.filter(function (v) { return banned.indexOf(v) < 0; });
    if (!ok.length) ok = list;
    return ok[Math.floor(Math.random() * ok.length)];
  }
  function assign(tile, animate) {
    var near = neighbours(tile);
    var shape = pick(SHAPES, near.map(function (t) { return t.getAttribute('data-offe-shape'); }), tile.getAttribute('data-offe-shape'));
    var color = pick(COLORS, near.map(function (t) { return t.getAttribute('data-offe-color'); }), tile.getAttribute('data-offe-color'));
    tile.setAttribute('data-offe-shape', shape);
    tile.setAttribute('data-offe-color', color);
    tile.style.setProperty('--fmm-morph-bg', color);
    tile.style.setProperty('--fmm-morph-rest', 'var(--shape-' + shape + '-rest)');
    tile.style.setProperty('--fmm-morph-hover', 'var(--shape-' + shape + '-hover)');
    if (!animate) return;
    var img = tile.querySelector('.fmm__tile-img');
    if (!img) return;
    img.style.transition = 'none';
    img.style.clipPath = 'var(--shape-' + shape + '-rest)';
    void img.offsetWidth;
    img.style.transition = '';
    img.style.clipPath = '';
  }
  function desktop() { return window.matchMedia('(min-width: 1160px)').matches; }
  function onEnter(e) {
    if (!desktop()) return;
    var tile = e.target.closest && e.target.closest('.list-menu--inline .fmm .fmm__tile--shape');
    if (!tile || (e.relatedTarget && tile.contains(e.relatedTarget))) return;
    assign(tile, true);
  }
  function init() {
    if (!desktop()) return;
    document.querySelectorAll('.list-menu--inline .fmm .fmm__tile--shape').forEach(function (t) { assign(t, false); });
  }
  document.addEventListener('mouseover', onEnter);
  document.addEventListener('focusin', onEnter);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/*
  Spotlight cards: same random shapes / colours and rules as the drop-down
  tiles; a pick on page load (phones too) and on each desktop hover. Sets
  --spot-shape-rest / -hover and --spot-morph-backdrop on the card.
*/
(function () {
  var SHAPES = ['clover', 'star', 'scallop']; // Offe's shapes only (no burst)
  var COLORS = ['#ff693d', '#bdbe40', '#a9defe', '#7598e9', '#629b26', '#c1b3ff'];
  function pick(list, banned, own) {
    var ok = list.filter(function (v) { return banned.indexOf(v) < 0 && v !== own; });
    if (!ok.length) ok = list.filter(function (v) { return banned.indexOf(v) < 0; });
    if (!ok.length) ok = list;
    return ok[Math.floor(Math.random() * ok.length)];
  }
  function assign(card, animate) {
    var near = [card.previousElementSibling, card.nextElementSibling].filter(function (c) {
      return c && c.classList.contains('spotlight-cards__item');
    });
    var shape = pick(SHAPES, near.map(function (c) { return c.getAttribute('data-offe-shape'); }), card.getAttribute('data-offe-shape'));
    var color = pick(COLORS, near.map(function (c) { return c.getAttribute('data-offe-color'); }), card.getAttribute('data-offe-color'));
    card.setAttribute('data-offe-shape', shape);
    card.setAttribute('data-offe-color', color);
    card.style.setProperty('--spot-shape-rest', 'var(--shape-' + shape + '-rest)');
    card.style.setProperty('--spot-shape-hover', 'var(--shape-' + shape + '-hover)');
    card.style.setProperty('--spot-morph-backdrop', color);
    if (!animate) return;
    var img = card.querySelector('.spotlight-cards__image-wrapper img');
    if (!img) return;
    img.style.transition = 'none';
    img.style.clipPath = 'var(--shape-' + shape + '-rest)';
    void img.offsetWidth;
    img.style.transition = '';
    img.style.clipPath = '';
  }
  function onEnter(e) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var card = e.target.closest && e.target.closest('.spotlight-cards__item');
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    assign(card, true);
  }
  function init() {
    document.querySelectorAll('.spotlight-cards__item').forEach(function (c) { assign(c, false); });
  }
  document.addEventListener('mouseover', onEnter);
  document.addEventListener('focusin', onEnter);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/*
  Phone menu drawer: a "<" in the top row goes back a level (or closes the
  drawer); tapping a category name opens its sub-menu.
*/
(function () {
  function add() {
    var heading = document.querySelector('#menu-drawer .modal__heading');
    if (!heading || heading.querySelector('.offe-drawer-back')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'offe-drawer-back focus-inset';
    btn.setAttribute('aria-label', 'Back');
    btn.addEventListener('click', function () {
      var open = Array.prototype.slice.call(document.querySelectorAll('#menu-drawer details[open] > .mobile-submenu .mobile-submenu__back'));
      var back = open[open.length - 1];
      if (back) { back.click(); return; }
      var close = document.getElementById('mobile-menu-close-btn');
      if (close) close.click();
    });
    heading.insertBefore(btn, heading.firstChild);
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('#menu-drawer details > summary .menu-drawer__menu-link');
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    link.closest('summary').click();
  }, true);
  // Promo tiles: random shape / colour, never the same as the one above.
  function shapeTiles() {
    var SHAPES = ['clover', 'star', 'scallop'];
    var COLORS = ['#ff693d', '#bdbe40', '#a9defe', '#7598e9', '#629b26', '#c1b3ff'];
    function pick(list, banned) {
      var ok = list.filter(function (v) { return banned.indexOf(v) < 0; });
      if (!ok.length) ok = list;
      return ok[Math.floor(Math.random() * ok.length)];
    }
    document.querySelectorAll('#menu-drawer .mobile-submenu__tiles').forEach(function (group) {
      var prevShape = null, prevColor = null;
      group.querySelectorAll(':scope > .fmm__tile--shape').forEach(function (tile) {
        var shape = pick(SHAPES, [prevShape]);
        var color = pick(COLORS, [prevColor]);
        tile.style.setProperty('--fmm-morph-bg', color);
        tile.style.setProperty('--fmm-morph-rest', 'var(--shape-' + shape + '-rest)');
        tile.style.setProperty('--fmm-morph-hover', 'var(--shape-' + shape + '-hover)');
        tile.setAttribute('data-offe-shape', shape);
        tile.setAttribute('data-offe-color', color);
        prevShape = shape; prevColor = color;
      });
    });
  }
  function init() { add(); shapeTiles(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Collection pages: .offe-stuck on the FILTER / SORT bar once it sticks. */
(function () {
  function init() {
    var bar = document.querySelector('.template-collection .collection-top');
    var hero = document.querySelector('.template-collection .collection-hero');
    if (!bar || !hero) return;
    var ticking = false;
    function check() {
      ticking = false;
      var stuck = hero.getBoundingClientRect().bottom < bar.getBoundingClientRect().bottom - 2;
      bar.classList.toggle('offe-stuck', stuck);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }, { passive: true });
    window.addEventListener('resize', check);
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();